import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/home.vue'),
        meta: {
            title: '首页'
        }
        // component: Home
    },
    // {
    //     path: '/info', //新装-信息填写
    //     name: 'Info',
    //     component: () =>
    //         import ( /* webpackChunkName: "Info" */ '../views/Info.vue')
    // },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router